const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: '200px',
    },
    sx: {
      '& .MuiMenuItem-root': {
        color: '#3F3F6E',
        fontSize: '14px',
        fontWeight: 600,
        textTransform: 'capitalize',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        '&.Mui-selected': {
          backgroundColor: '#fdeee7 !important',
          '&:hover': {
            backgroundColor: '#fcddcf !important',
          },
        },
      },
    },
  },
};

export const getStatusMenuProps = (isCompactLayout) => ({
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: isCompactLayout ? '100%' : '200px',
    },
    sx: MenuProps.PaperProps.sx,
  },
});

export const sharedInputSx = {
  '& .MuiInputLabel-root': {
    color: '#3F3F6E',
    fontSize: '13px',
    fontWeight: 500,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#3F3F6E',
  },
  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    color: '#3F3F6E',
    fontWeight: 500,
    paddingLeft: '4px',
  },
  '& .MuiOutlinedInput-root': {
    height: '42px',
    borderRadius: '5px',
    backgroundColor: '#fff',
    transition: 'all 0.2s ease',
    '& fieldset': {
      borderWidth: '1px',
      borderColor: '#D7E0F2',
    },
    '&:hover fieldset': {
      borderColor: '#3F3F6E',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3F3F6E',
      borderWidth: '1px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3F3F6E !important',
    },
    '& input': {
      fontSize: '13px',
    },
    '& .MuiSelect-select': {
      fontSize: '13px',
      color: '#3F3F6E',
      textTransform: 'capitalize',
    },
    '& .MuiSelect-icon': {
      color: '#3F3F6E',
    },
  },
};
